import { EXO_SKELETON_EVENT_NAMES } from '../consts';
import { createPostMessageEventHandler, hasExoSkeletonListenerInitialized, sendRuntimeDataEvent } from '../runtime';
const IMPORT_REMOTE_MESSAGE_EVENT_NAME = EXO_SKELETON_EVENT_NAMES.IMPORT_REMOTE_MESSAGE_EVENT_NAME;
function isImportRemoteDataEvent(data) {
  return (data === null || data === void 0 ? void 0 : data.type) === IMPORT_REMOTE_MESSAGE_EVENT_NAME;
}
/**
 * Used to create a host for the ExoSkeleton.
 */
export function createImportRemoteListener(_ref) {
  let {
    onImportRemote
  } = _ref;
  return createPostMessageEventHandler(IMPORT_REMOTE_MESSAGE_EVENT_NAME, function (_ref2) {
    let {
      data
    } = _ref2;
    if (isImportRemoteDataEvent(data)) {
      onImportRemote(data);
    }
  });
}
export function sendImportRemoteRuntimeEvent(_ref3) {
  let {
    scope,
    metadata
  } = _ref3;
  if (!hasExoSkeletonListenerInitialized(IMPORT_REMOTE_MESSAGE_EVENT_NAME)) {
    console.warn('"sendImportRemoteRuntimeEvent" was called, but the ExoSkeleton host did not initialize the "createImportRemoteListener". Data sent:', {
      scope,
      metadata
    });
  }
  return sendRuntimeDataEvent(IMPORT_REMOTE_MESSAGE_EVENT_NAME, {
    scope,
    metadata
  });
}
//# sourceMappingURL=events.js.map